export default __webpack_public_path__ + "static/media/FeverLand_11.29f4bf96.png";